export default __webpack_public_path__ + "static/media/fire-resistant.bfb8e488.svg";